import axios from 'axios';
import { replaceAllUrlPhoto } from '~/shared/utils/replaceUtils';
import Service from '~/shared/Service';

const config = {
  headers: {
    'Content-Type': 'video/mp4'
  }
};

export default {
  setLoader(context, payload) {
    context.commit('appLoader', payload);
  },
  setModalMessage(context, payload) {
    context.commit('appModalMessage', payload);
  },
  setMessage(context, payload) {
    context.commit('appMessage', payload);
  },
  updateSearchPolis(context, payload) {
    context.commit('updateSearchPolis', payload);
  },
  async getBank(context, country) {
    try {
      const { data } = await this.$axios.get(`/banks?countryCode=${country}&&limit=999`);
      const response = data.data;
      context.commit('updateDataBank', response);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async getBase64(context, { urlLink, type }) {
    const urlReplace = urlLink.replace('/api/', '/v1/');
    console.log(urlReplace, type);
    try {
      const { data } = await this.$axios.get(type === 'image' ? urlReplace : urlLink);
      return data;
    } catch (error) {
      return error;
    }
  },
  async callCountryCode(context, route) {
    try {
      const { data } = await this.$axios.get('/country-detect');
      const { country } = data;
      context.commit('updateCountryCode', country);
      if (route) {
        const { path: currentPath, name } = route;

        let lang;
        if (context.rootGetters['user/getUserData']) {
          lang = context.rootGetters['user/getUserData'].lang;
        }

        let goToPath = '';

        // if lang is undefined
        if (!lang) {
          switch (country) {
            case 'ID':
              // Indonesian
              goToPath = name.indexOf('index___') >= 0 ? this.app.localePath('index') : this.app.switchLocalePath('id');
              break;
            case 'MY':
              // Malay
              goToPath = this.app.switchLocalePath('ms');
              break;
            case 'VN':
              // Vietname
              goToPath = `${this.app.switchLocalePath('vi')}/`;
              break;
            case 'TH':
              // Thailand
              goToPath = `${this.app.switchLocalePath('th')}/`;
              break;
            default:
              // English is fallback
              goToPath = this.app.switchLocalePath('en');
          }
        } else if (lang === 'id') {
          goToPath = this.app.switchLocalePath('id');
        } else {
          goToPath = this.app.switchLocalePath(lang);
        }

        // If go to path is same with current path, don't replace again.
        if (!currentPath.includes(goToPath)) {
          this.$router
            .replace(goToPath)
            // The last hope if the NavigationDuplicate is still going :(
            .catch(() => {});
        }
      }
      return data;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async callRegion(context, country) {
    try {
      const { data } = await Service.post('/region', { ...country });
      context.commit('updateLocaleLanguage', data.data.languages);
      return data;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async callPickUpDates(context) {
    try {
      const { data } = await axios.get('https://api-staging.qoala.app/api/business-calendar');
      context.commit('updateInfoDates', data.data);
      const response = data.data;
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async callAddress(context, params) {
    try {
      let response;
      const url = 'https://api-staging.qoala.app/api/list-of-province-zipcode';
      if (params.zipcode) {
        const { data } = await axios.get(`${url}?zipcode=${params.zipcode}`);
        response = data.data;
      } else if (params.province) {
        if (params.city) {
          const { data } = await axios.get(`${url}?province=${params.province}&city=${params.city}`);
          context.commit('updateAddressDistrict', data.data);
          response = data.data;
        }
        if (params.district) {
          const { data } = await axios.get(
            `${url}?province=${params.province}&city=${params.city}&district=${params.district}`
          );
          context.commit('updateAddressVillage', data.data);
          response = data.data;
        } else {
          const { data } = await axios.get(`${url}?province=${params.province}`);
          context.commit('updateAddressCity', data.data);
          response = data.data;
        }
      } else {
        const { data } = await axios.get(url);
        context.commit('updateAddressProvince', data.data);
        response = data.data;
      }
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async uploadPresignedFile(context, { dataSend, policyType, callback }) {
    try {
      const { supportingDocument } = dataSend || [];
      const cloneDataSend = Object.assign({}, dataSend);
      const files = [];
      const documentSend = [];
      for (let index = 0; index < supportingDocument.length; index++) {
        const element = supportingDocument[index];
        const extensionArray = element.filename.split('.');
        const extension = extensionArray[extensionArray.length - 1];
        files.push({
          documentable: 'claim',
          type: element.type,
          filename: `${index}.${extension}`
        });
      }
      const { data } = await axios.post(`${process.env.API_BASE_URL}/bus/documents/presigned`, {
        files
      });
      for (let index = 0; index < supportingDocument.length; index++) {
        const element = supportingDocument[index];
        const elementIndex = files[index].filename;
        const elementData = data.data[elementIndex];
        const urlPresigned = elementData.presigned_url;
        const buffer = Buffer.from(element.content, 'base64');

        elementData.type = element.type;
        documentSend.push(elementData);
        axios.put(urlPresigned, buffer, {
          headers: {
            'Content-Type': '*',
            reportProgress: true
          }
        });
      }
      cloneDataSend.supportingDocument = documentSend;
      return callback(cloneDataSend, policyType);
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async hitArticles(context) {
    try {
      const { data } = await axios.get(`${process.env.WORDPRESS}/wp-json/wp/v2/posts`);
      const response = data;
      context.commit('updateArticles', replaceAllUrlPhoto(response));
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async getDetailArticle(context, { id }) {
    try {
      const { data } = await axios.get(`${process.env.WORDPRESS}/wp-json/wp/v2/posts/${id}`);
      const response = data;
      context.commit('updateDetailArticle', replaceAllUrlPhoto(response));
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async hitPromos(context) {
    try {
      const { data } = await axios.get('https://qoala-cms.herokuapp.com/promos?_sort=_id:DESC');
      const response = data;
      context.commit('updatePromos', response);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  // async userPhone(context, params) {
  //   try {
  //     let response;
  //     if (params.id) {
  //       const { data } = await axios.get(
  //         `${process.env.API_BASE_URL}/smartphone/list-brands/${params.id}?orderBy=${params.query.orderBy}&limit=${params.query.limit}`
  //       );
  //       context.commit('updatePhoneModel', data.data);
  //       response = data.data;
  //     } else {
  //       const { data } = await axios.get(
  //         `${process.env.API_BASE_URL}/smartphone/list-brands?orderBy=${params.query.orderBy}&limit=${params.query.limit}`
  //       );
  //       context.commit('updatePhoneBrand', data.data);
  //       response = data.data;
  //     }
  //     return response;
  //   } catch (error) {
  //     console.log(error);
  //     return error;
  //   }
  // },
  async getPresign(context, payload) {
    const dataSend = {
      filename: payload.filename,
      content_type: payload.content_type
    };
    try {
      const { data } = await this.$axios.put(`/smartphone/policies/activations/${payload.number}`, dataSend);
      const response = data.data;
      return response;
    } catch (err) {
      return err;
    }
  },
  async hitPresignUrl(context, { video, url }) {
    context.commit('appLoader', true);
    try {
      const data = await axios.put(url, video, config);
      const response = data.data;
      return response;
    } catch (err) {
      console.log(err);
      return err;
    }
  },
  async getInsurancePartner(context) {
    try {
      const data = await this.$axios.get('/users/insurances?status=active');
      const response = data.data.data;
      let partners = [];
      response.forEach(partner => {
        if (partner.config.logo) {
          partners.push({
            alias: partner.alias,
            name: partner.name,
            logo: partner.config.logo
          });
        }
      });
      context.commit('updateInsurancePartner', partners);
    } catch (err) {
      console.log(err);
      return err;
    }
  },
  async transactionHistory(context, { query }) {
    try {
      const { data } = await this.$axios.get(`${process.env.API_BASE_URL}/transactions/histories?${query}`);
      const response = data.data;
      context.commit('updateTransactionHistory', response);
      return response;
    } catch (err) {
      return err;
    }
  },
  async requestCx(context, payload) {
    try {
      await axios.post(`${process.env.API_BASE_URL}/request/call`, payload);
    } catch (err) {
      throw err;
    }
  },
  async requestProduct(context, payload) {
    try {
      await axios.post(`${process.env.API_BASE_URL}/request/product`, payload);
      // return response;
    } catch (err) {
      throw err;
    }
  },
  async requestRenewal(context, payload) {
    try {
      await axios.post(`${process.env.API_BASE_URL}/request/renewal`, payload);
    } catch (err) {
      throw err;
    }
  },
  async requestEmployeeBenefit(context, payload) {
    try {
      await axios.post(`${process.env.API_BASE_URL}/request/employeeBenefit`, payload);
    } catch (err) {
      throw err;
    }
  },
  async getSharedId(context, payload) {
    try {
      const response = axios.post(`${process.env.API_BASE_URL}/prequote/share`, payload);
      return response;
    } catch (err) {
      return err;
    }
  },
  async getSharedProduct(context, payload) {
    try {
      const response = axios.get(`${process.env.API_BASE_URL}/prequote/share/${payload}`);
      return response;
    } catch (err) {
      return err;
    }
  },
  async getPdfUrl(context, { payload, query }) {
    try {
      const response = axios.get(`${process.env.API_BASE_URL}/products/${payload}/pdf?${query}`);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
};
